import { cameraProps, CameraMode } from '../state/camera-state';
import { performCameraTween } from './perform-camera-tween';
import { startCameraTween } from './start-camera-tween';
import { getCameraPerspectiveByIndex } from './get-camera-perspective-by-index';
import { getCameraTweenProgress } from './get-camera-tween-progress';
import { performCameraRealignment } from './perform-camera-realignment';

export const isCameraRealignmentInProgress = (elapsedTime: number) => {
  if (cameraProps.mode === CameraMode.ControlledByMainLoop) {
    performCameraRealignment(elapsedTime);
  }
};

export const onProgressChange = () => {
  if (cameraProps.mode === CameraMode.ControlledByTimeline) {
    performCameraTween(getCameraTweenProgress());
  }
};

export const changeMode = (mode: CameraMode) => {
  if (cameraProps.mode !== mode) {
    cameraProps.mode = mode;
  }
};

let lastPerspectiveName = '';

export const changePerspectiveByIndex = (
  index: number,
  mode: CameraMode,
  windForward: boolean
) => {
  const perspective = getCameraPerspectiveByIndex(index);

  // Avoid restarting tween when camera is controlled by timeline
  // and if camera is already moving to this target
  if (
    mode === CameraMode.ControlledByTimeline &&
    perspective.positionOf === lastPerspectiveName
  ) {
    return;
  }

  // console.info(perspective);

  lastPerspectiveName = perspective.positionOf;

  cameraProps.tweenTotalTime = perspective.inSeconds;
  cameraProps.reverseCameraTween = windForward;
  cameraProps.tweenCurrentTime = 0;
  cameraProps.tweenProgress = 0;
  cameraProps.mode = mode;

  startCameraTween(perspective);
};
